import { render, staticRenderFns } from "./remove-group.vue?vue&type=template&id=2a3d102b&scoped=true&"
import script from "./remove-group.vue?vue&type=script&lang=js&"
export * from "./remove-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d102b",
  null
  
)

export default component.exports